export default __webpack_public_path__ + "locales/az/People.json?hash=50bc7333e92e33bce3fb09c7aa64b910";